import {Branded} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';
import {NonNegativeDoubleString} from './NonNegativeDoubleString';
import {NonNegativeInt} from './NonNegativeInt';

interface NonNegativeDoubleStringRepresentationBrand {
    readonly NonNegativeDoubleStringRepresentation: unique symbol;
}

export type NonNegativeDoubleStringRepresentation = Branded<NonEmptyString, NonNegativeDoubleStringRepresentationBrand>;

export const createNumberRepresentation = (
    amount: NonNegativeDoubleString,
    minimalDecimals: NonNegativeInt,
    maximalDecimals: NonNegativeInt,
    locale: string
): NonNegativeDoubleStringRepresentation => {
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: minimalDecimals,
        maximumFractionDigits: maximalDecimals,
    }).format(amount as any) as NonNegativeDoubleStringRepresentation; // FIXME format supports string input - override its declaration and remove 'as any' typecast
};
